/**
 * @see https://developers.google.com/youtube/iframe_api_reference#Events
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = ["ready", "stateChange", "playbackQualityChange", "playbackRateChange", "error", "apiChange"];
module.exports = exports["default"];
//# sourceMappingURL=eventNames.js.map


//////////////////
// WEBPACK FOOTER
// ./~/youtube-player/dist/es5/eventNames.js
// module id = 2549
// module chunks = 2